module.exports = __webpack_public_path__ + "img/horizontal_6_5_pp3_3016.260d92ac.png";